import axios from "axios"
import reportError from "../interceptors/reportError"

const apiClient = () => {
  const baseURL = process.env.VUE_APP_API_GATEWAY_URL_V2
  const header = {
    "Content-Type": "application/json"
  }

  const api = axios.create({
    baseURL,
    "Cache-Control": "no-cache",
    headers: header
  })

  api.interceptors.response.use(
    response => response,
    error => reportError(error)
  )

  return api
}

export default {
  async verifyEvVehicle(registrationPlate) {
    const { data } = await apiClient().post("api/v1/dvla/checkVehicleIsEv", {
      registrationPlate
    })
    return data
  },
  async verifySmartMeter(meterPointIdentifier) {
    const { data } = await apiClient().get(
      `api/v1/meterPoints/${meterPointIdentifier}/ees/checkEvTariffEligibility`
    )
    return data
  }
}
